import { Link } from "react-router-dom";

type SideMenuItemProps = {
  isSelected?: boolean;
  text: string;
  image: React.ReactNode | string;
  imageSelected?: string;
  expanded?: boolean;
  linkUrl?: string | (() => unknown);
  testId: string;
};

function SideMenuItem(props: SideMenuItemProps) {
  const { isSelected, text, image, linkUrl, expanded, imageSelected, testId } = props;

  return (
    <Link
      to={typeof linkUrl === "string" ? linkUrl : "#"}
      css={{
        display: "flex",
        gap: 9,
        alignItems: "center",
        textDecoration: "none",
        color: "var(--swing-gray-200)",
        padding: 10,
        borderRadius: 8,
        width: "100%",
        "&:hover": {
          color: "white",
        },
        ...(isSelected && {
          backgroundColor: "var(--swing-yellow-500)",
          color: "var(--swing-blue-200)",
          "&:hover": {
            color: "var(--swing-blue-200)",
          },
        }),
      }}
      onClick={typeof linkUrl === "string" ? undefined : linkUrl}
      data-testid={testId}
    >
      {typeof image === "string" ? (
        <img
          src={isSelected ? imageSelected : image}
          alt=""
          css={{
            height: 24,
            width: 24,
            objectFit: "contain",
          }}
          referrerPolicy="no-referrer"
        />
      ) : (
        image
      )}
      {expanded && (
        <div
          css={{
            fontSize: 14,
            fontWeight: 400,
            whiteSpace: "nowrap",
            ...(isSelected && {
              fontWeight: 500,
            }),
          }}
        >
          {text}
        </div>
      )}
    </Link>
  );
}

export default SideMenuItem;
